export function toFormData<T extends object>(data: T): FormData {
  const formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    if (
      typeof value === 'object' &&
      value !== null &&
      !(value instanceof File)
    ) {
      formData.append(key, JSON.stringify(value));
      continue;
    }
    formData.append(key, value);
  }
  return formData;
}
